import { Launch } from '@carbon/icons-react';
import classNames from 'classnames';

export default function ExternalLink({ href, text, className }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={classNames('underline hover:underline inline-flex items-center gap-1', className)}
    >
      {text}
      <Launch />
    </a>
  );
}
